// Campus photo for /colleges/wichita-state-university: CC0 1.0, by Staryu, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUlrich_Museum.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/wichita-state-university/; credited under the photo.
const photo = {
    "slug": "wichita-state-university",
    "alt": "The Ulrich Museum of Art and its large Joan Miro mosaic mural on the Wichita State University campus in Wichita, Kansas",
    "src": "/colleges/wichita-state-university/campus-1600.webp",
    "srcSmall": "/colleges/wichita-state-university/campus-800.webp",
    "srcMid": "/colleges/wichita-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/wichita-state-university/og.jpg",
    "title": "Ulrich Museum",
    "author": "Staryu",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUlrich_Museum.jpg",
    "read": "2026-10-01"
};

export default photo;
